// src/services/favoritesService.ts
import { supabase } from '../lib/supabase'

export const createFavoritesService = () => {
  return {
    async addFavorite(userId: string, movieId: string) {
      const { data, error } = await supabase
        .from('favorites')
        .insert({ user_id: userId, movie_id: movieId, watched: false })
        .select()
       
      if (error) throw error
      return data
    },

    async removeFavorite(userId: string, movieId: string) {
      const { error } = await supabase
        .from('favorites')
        .delete()
        .match({ user_id: userId, movie_id: movieId })
       
      if (error) throw error
    },

    async getUserFavorites(userId: string): Promise<{ movie_id: string; watched: boolean }[]> {
      const { data, error } = await supabase
        .from('favorites')
        .select('movie_id, watched')
        .eq('user_id', userId)
       
      if (error) {
        console.error('Error fetching user favorites:', error);
        throw error;
      }
      return data?.map((fav: { movie_id: string; watched: boolean }) => fav) || []
    },

    async updateFavoriteWatchedStatus(userId: string, movieId: string, watched: boolean) {
      const { data, error } = await supabase
        .from('favorites')
        .update({ watched })
        .match({ user_id: userId, movie_id: movieId })
        .select();

      if (error) throw error;
      return data;
    }
  }
}